import type {RouteRecordRaw} from "vue-router";

import {EPermissao} from "@/core/type/permissao.type";

export const transferenciaRoutes: RouteRecordRaw[] = [
    {
        path: "/transferencia",
        name: "transferencia",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_LISTAR_TRANSFERENCIAS},
        component: () => import("@/modules/transferencia/pages/PageTransferencia.vue")
    },
];
